import React, { useState } from 'react';
import storageManager from '../../utils/storageManager';

const StorageClearButton = () => {
  const [showButton, setShowButton] = useState(false);
  const [isClearing, setIsClearing] = useState(false);

  // Check if we should show the clear button
  React.useEffect(() => {
    const checkStorageUsage = () => {
      const usage = storageManager.getStorageUsage();
      const percentage = (usage / storageManager.MAX_TOTAL_STORAGE) * 100;

      // Show button if storage is over 80% full
      if (percentage > 80) {
        setShowButton(true);
      }
    };

    checkStorageUsage();

    // Check periodically
    const interval = setInterval(checkStorageUsage, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const handleClearStorage = async () => {
    if (window.confirm('This will clear all stored data. Are you sure you want to continue?')) {
      setIsClearing(true);
      try {
        storageManager.clearAllData();
        setShowButton(false);
        alert('Storage cleared successfully! The page will refresh.');
        window.location.reload();
      } catch (error) {
        console.error('Error clearing storage:', error);
        alert('Failed to clear storage. Please try refreshing the page.');
      } finally {
        setIsClearing(false);
      }
    }
  };

  if (!showButton) {
    return null;
  }

  return (
    <div className="fixed top-5 right-5 z-50 bg-white border-2 border-red-400 rounded-lg p-3 shadow-lg max-w-xs">
      <button
        className={`w-full mb-2 px-4 py-2 text-sm font-semibold text-white rounded transition-colors ${
          isClearing
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-red-500 hover:bg-red-600'
        }`}
        onClick={handleClearStorage}
        disabled={isClearing}
      >
        {isClearing ? 'Clearing...' : 'Clear Storage (Quota Full)'}
      </button>
      <div className="text-xs text-gray-600 text-center leading-relaxed">
        Storage quota is nearly full. Click to clear old data.
      </div>
    </div>
  );
};

export default StorageClearButton;
